<template>
    <div class="microTrain" id="matchResult">
        <a-back-top />
        <div class="microTrainTop dfafe">
            <p style="color:#333333;font-size:26px;">
                微能力认证结果
                <span style="color:#666666;font-size:16px;">
                    排列顺序非名次顺序，仅供认证结果展示。
                </span>
            </p>
        </div>
        <div style="background-color:white;padding: 30px 0 0 0;">
            <div style="background-color:white;margin: 0;" v-if="showTable && onload">
                <a-carousel :dot-position="'bottom'" :before-change="onChange" :autoplay="true" arrows>
                    <div
                        slot="prevArrow"
                        slot-scope="props"
                        class="custom-slick-arrow"
                        style="left: 10px;zIndex: 1"
                    >
                        <a-icon type="left-circle" />
                    </div>
                    <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                        <a-icon type="right-circle" />
                    </div>
                    <div v-for="(item, index) in totalPage">
                        <a-table :columns="columns" :data-source="data" :pagination="false">
                            <span slot="taskJobs" slot-scope="taskJobs" style="width: 260px !;">
                                <span v-for="(item, index) in taskJobs" style="display:block;line-height: 30px;width: 260px;" class="imgimgimg">
                                    {{ item.microNo }}.{{ item.microName }}
                                    <span v-if="item.score >= 86"><img src="../../../static/images/zimg114.png" alt=""></span>
                                    <span v-else-if="item.score >= 60"><img src="../../../static/images/zimg115.png" alt=""></span>
                                    <span v-else="item.score < 60"><img src="../../../static/images/zimg116.png" alt="" class="img"></span>
                                </span>
                            </span>
                            <span slot="courseViewId" slot-scope="courseViewId">
                                <span @click="goact(courseViewId.courseViewId)" style="color:#1890FF;cursor: pointer;">{{ courseViewId.courseName ? "《" + courseViewId.courseName + "》" : ""}}</span>
                            </span>
                        </a-table>
                    </div>
                </a-carousel>
                <br><br><br><br>
            </div>
            <div class="matchResultImg" v-if="!showTable && onload">
                <img src="../../../static/images/zimg101.png" alt="">
            </div>
            <div v-if="!showTable && onload" style="color:#333333;font-size:18px;text-align: center;padding: 0 0 30px 0;">
                活动正在火热筹备中，比赛结果将在赛事结束后进行揭晓~
            </div>
        </div>
        <br><br>
        <div class="microTrainTop dfafe">
            <p style="color:#333333;font-size:26px;">
                微能力PK榜
            </p>
        </div>
        <div style="background-color:white;padding: 55px 0 30px 0;">
            <div style="margin: 0 auto 20px;width: 80%;">
                <img style="width: 100%;" src="../../../static/images/zimg117.png" alt="">
            </div>
        </div>
        <br><br>
    </div>
</template>

<script>
    const columns = [
    {
    },
    {
        title: '姓名',
        dataIndex: 'realName',
        // align: 'center'
        // key: 'userId',
    },
    {
        title: '学校',
        dataIndex: 'deptName',
        // align: 'center'
        // key: 'userId',
    },
    {
        title: '认证微能力点及等级',
        dataIndex: 'taskJobs',
        scopedSlots: { customRender: 'taskJobs' },
    },
    {
        title: '认证课例',
        // key: 'courseViewId',
        scopedSlots: { customRender: 'courseViewId' },
    },
    ];


  export default {
    data() {
      return {
        current: 1,
        pageSize: 6,
        dotPosition: 'bottom',
        totalPage: [],
        columns,
        data:[],
        showTable:false,
        onload: false
      }
    },
    props: ['changeTab'],
    components: {

    },
    mounted () {
        this.getMicroAbilityAuthenResult();
    },
    created(){

    },
    methods: {
        onChange (from,to){
            // console.log(from,to);
            this.current = parseInt(to)+1;
            this.getMicroAbilityAuthenResult();
        },
        getMicroAbilityAuthenResult (){
            this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.getMicroAbilityAuthenResult+'?currentPage='+this.current+'&pageSize='+this.pageSize),{
                "where": {
                    // "projectId_eq": "c050ec35d69f467a9d2cdb0b463d4499",
                    "projectId_eq": "1608f1f4c46f43f0b119d214e3fb1a89",
                    "userId_ne":"ed332098c0a801b94fcc8c6a6176669d"
                }
            })
            .then((res)=>{
                console.log(res);
                if (res.data.pageInfo.totalCount > 0){
                    this.showTable = true;
                }
                this.onload = true;
                this.totalPage = [];
                for (let i = 0 ; i < res.data.pageInfo.totalPage ; i++){
                    this.totalPage.push(i);
                }
                this.data = res.data.data;
                this.show = true;
            }).catch((err)=> {
                console.log(err);
            });
        },
        goact(id){
            this.$emit('changeTab');
            this.$router.push('/videoDetail?videoid='+id);
        }
    }
  }
</script>

<style lang="scss">
    .h60{
        height: 60px;
    }
    .bgF3{
        background-color: #F3FBFF;
    }
    .c3{
        color: #333333;
    }
    .c9{
        color: #999999;
    }
    .f24{
        font-size: 24px;
    }
    .f18{
        font-size: 18px;
    }
    .pd20_0{
        padding: 20px 0;
    }
    .pd0_20{
        padding: 0 20px;
    }
    .pd20{
        padding: 20px;
    }
    .pd10{
        padding: 10px;
    }
    .fw{
        font-weight: bold;
    }
    .dfsbc{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .dfsbe{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .dfaf{
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
    }
    .dfafe{
        display: flex;
        justify-content: flex-start;
        align-content: flex-end;
        align-items: flex-end;
    }
    .microTrain{
        width: 1200px;
        margin: 64px auto 0;
        .microTrainTop{
            padding: 35px 0 15px;
        }
    }
    .matchResultImg{
        height: 40vh;
        margin: 0 auto 20px;
        img{
            height: 100%;
        }
    }
    .ant-carousel .slick-dots-bottom{
      bottom: -34px;
    }
    .ant-carousel .slick-slide {
      text-align: center;
      // height: 160px;
      // line-height: 160px;
      overflow: hidden;
    }
    .ant-carousel .slick-dots li button {
      width: 7px;
      height: 7px;
      background: #2680EB;
      border-radius: 50%;
      opacity: 0.47;
    }
    .ant-carousel .slick-dots li.slick-active button{
      width: 10px;
      height: 10px;
      transform: translate(0px, -1px);
      opacity: 1;
      background-color: #2680EB;
    }
    .ant-carousel .slick-dots{
      height: 10px;
      line-height: 10px;
    }
    .ant-carousel >>> .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.ant-table-tbody tr:nth-last-of-type(2n-1){
    background-color: #F8FAFB;
}
#matchResult .imgimgimg img{
    display: inline-block;
    width: 40px;
    height: 23px;
}
#matchResult .imgimgimg .img{
    width: 53px;
}
.ant-table-tbody > tr > td{
    border-bottom: none;
}
.ant-table-tbody > tr{
    padding: 0 50px;
}
.ant-table-thead > tr > th{
    background-color: white;
}
</style>
